import { createSlice } from '@reduxjs/toolkit'
import type { RootState } from '..'

interface UserProfileData {
  userEmail: string
  userName: string
}

interface UserManagementProfileState {
  selectedUserProfile: UserProfileData
}

const initialState: UserManagementProfileState = {
  selectedUserProfile: {
    userEmail: '',
    userName: '',
  },
}

export const userManagementProfileSlice = createSlice({
  name: 'userManagementProfile',
  initialState,
  reducers: {
    setSelectedUserProfileData: (state, { payload }) => {
      state.selectedUserProfile = payload
    },
  },
})

export const getSelectedUserProfileData = (state: RootState) =>
  state.userManagementProfile.selectedUserProfile

export const { setSelectedUserProfileData } = userManagementProfileSlice.actions
export default userManagementProfileSlice.reducer
